import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps-withscopedautocomp'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBZag6oUZU3ECfWhDPoVC8y5cwb377HbUI',
    libraries: 'places'
  },
})
